import { ResponseModel, handleGetAsync, handlePostAsync, handlePutAsync, handleDeleteAsync } from "../../components/common/commonclass";
import { EndPoint } from "../../components/common/config";
import { handleNotify, TOASTER_POSITION, TOASTER_TYPE } from "../../components/common/notification/toaster_notify.component";

var responseModel = new ResponseModel();

export class ProbabilityService {
    // Get All 
    static async getAllProbabilities(storeId = null) {
        responseModel = new ResponseModel();
        const requestURL = EndPoint.PROBABILITY; // endpoint 
        const requestModel = { storeId };
        responseModel = await handleGetAsync(requestURL, true, requestModel);
        if (responseModel) {
            return responseModel;
        } else {
            console.error('Failed to fetch probabilities.');
            return [];
        }
    }

    // Create 
    static async addNewProbability(data) {
        responseModel = new ResponseModel();
        const requestURL = EndPoint.PROBABILITY; // endpoint 

        responseModel = await handlePostAsync(requestURL, true, data);

        if (responseModel) {
            handleNotify('Probability added successfully!', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            throw new Error('Failed to create new probability.');
        }
    }

    // Get by ID
    static async getProbabilityById(id) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.PROBABILITY}/${id}`; // endpoint 

        responseModel = await handleGetAsync(requestURL, true);
        if (responseModel) {
            return responseModel;
        } else {
            throw new Error('Failed to fetch probability by ID');
        }
    }

    // Update 
    static async updateProbabilityById(id, data) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.PROBABILITY}/${id}`; // endpoint 

        responseModel = await handlePutAsync(requestURL, true, data);
        if (responseModel) {
            handleNotify('Probability updated successfully.', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            throw new Error('Failed to update probability.');
        }
    }

    // Delete 
    static async deleteProbability(id) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.PROBABILITY}/${id}`; // endpoint 

        try {
            responseModel = await handleDeleteAsync(requestURL, true);
            if (responseModel) {
                return responseModel;
            } else {
                throw new Error('Failed to delete probability.');
            }
        } catch (error) {
            console.error('Error deleting probability:', error);
            throw error;
        }
    }

    // Delete Multiple
    static async deleteManyProbabilities(ids) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.PROBABILITY}/deletemany`; // endpoint

        responseModel = await handleDeleteAsync(requestURL, true, ids);
        if (responseModel) {
            handleNotify(responseModel.message, TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            handleNotify(responseModel.errormessage, TOASTER_TYPE.ERROR, TOASTER_POSITION.TOP_RIGHT);
        }
    }
}
